<template>
  <div>
    <a-button
      type="primary"
      @click="addControl('ict_eform_nguoi', 'Tên người yêu cầu')"
      :loading="loading"
    >
      Thêm currentUser control
    </a-button>
    <br />
    <a-button
      type="primary"
      @click="addControl('ict_eform_donvi', 'Đơn vị người yêu cầu')"
      :loading="loading"
    >
      Thêm đơn vị control
    </a-button>
    <br />
    <a-button
      type="primary"
      @click="addControl('ict_eform_ngay', 'Ngày tạo')"
      :loading="loading"
    >
      Thêm đơn vị control
    </a-button>
    <br />
  </div>
</template>
<script>
import {
  createContentControl,
  lockContentControl
} from "@/components/WordTemplates/contentControl.service";
const listControl = ["ict_eform_nguoi", "ict_eform_donvi", "ict_eform_ngay"];
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async addControl(id, title) {
      this.loading = true;
      // B1 tạo content control
      await createContentControl(id, title);
      // B2 khóa lại
      await lockContentControl(id);
      this.loading = false;
    }
  }
};
</script>
